module.exports = __webpack_public_path__ + "img/icon-visualizar.13f8e392.svg";